import { Reveal } from "../../lib/reveal";
import { EXPERTISE } from "../../data/content";

const Expertise = () => (
  <section data-testid="expertise-section" className="bg-white py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <div className="mb-16 grid gap-8 lg:grid-cols-2 lg:items-end">
        <Reveal>
          <p className="mb-4 flex items-center gap-3 text-[12px] font-bold uppercase tracking-[0.22em] text-bati-sky">
            <span className="h-px w-10 bg-bati-sky" /> Tous corps d'état
          </p>
          <h2 className="font-display text-4xl font-extrabold tracking-tight text-bati-ink sm:text-5xl">
            Une expertise globale<br />du bâtiment
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="max-w-lg text-base leading-relaxed text-bati-ink/60 lg:ml-auto">
            Entreprise générale du bâtiment, BÂTI 360 coordonne l'ensemble des corps de métier sur votre chantier. Un seul interlocuteur, une vision d'ensemble, une cohérence totale — de la structure aux finitions.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 gap-px bg-black/10 md:grid-cols-2 lg:grid-cols-3">
        {EXPERTISE.map((block, i) => (
          <Reveal key={block.num} delay={i * 0.07} className="h-full bg-white">
            <article className="group flex h-full flex-col justify-end p-8 transition-colors duration-300 hover:bg-bati-mist lg:p-10">
              {block.image && (
                <div className="mb-6 h-36 overflow-hidden">
                  <img
                    src={block.image}
                    alt={block.title}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.05]"
                  />
                </div>
              )}
              <span className={`font-display text-sm font-bold ${block.green ? "text-bati-green" : "text-bati-sky"}`}>{block.num}</span>
              <h3 className="mt-2 font-display text-2xl font-bold tracking-tight text-bati-ink transition-colors duration-300 group-hover:text-bati-blue">
                {block.title}
              </h3>
              <ul className="mt-5 space-y-2.5 border-t border-black/10 pt-5">
                {block.items.map((item) => (
                  <li key={item} className="flex items-start gap-2.5 text-sm text-bati-ink/65">
                    <span className={`mt-[7px] h-1.5 w-1.5 shrink-0 ${block.green ? "bg-bati-green" : "bg-bati-sky"}`} />
                    {item}
                  </li>
                ))}
              </ul>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Expertise;
